import WithToolTip from "../WithToolTip"
import "./styles.scss"

const TrustScorePill = ({ icon, bg, color, text, tooltipText, className = "" }) => {

    return (
        <WithToolTip
            title={tooltipText}
            showToolTip={!!tooltipText}
        >
            <div
                className={`score-pill width-68 pl-2 pr-4 py-2 b-20 flex items-center text-12 select-none ${className}`}
                style={{
                    background: "#F3F3F3",
                    borderRight: "none",
                }}
            >
                {
                    icon &&
                    <span style={{ background: bg }} className="px-8 py-4 mr-4 b-40">
                        {icon}
                    </span>
                }
                <p style={{ color: color }}>{text}</p>
            </div>
        </WithToolTip>
    )
}

export default TrustScorePill